// Catalogo unico de permisos de Cuory.
// k = llave que viaja al backend (models/User.js + validators/UserValidator.js)
// l = etiqueta que ve el usuario
// v = true  -> es un boton que valida, autoriza, ejecuta o cancela

export const CATALOGO_PERMISOS = [
  {
    grupo: "ARTICULOS",
    items: [
      { k: "menu_articulos", l: "Articulos" },
      { k: "articulos_create", l: "Crear articulos" },
      { k: "cambiaPrecios", l: "Cambiar precios" },
      { k: "ventaMinima", l: "Ingreso neto minimo" },
      { k: "menu_catalogos", l: "Catalogos" },
    ],
  },
  {
    grupo: "COMPRAS",
    items: [
      { k: "menu_proveedores", l: "Proveedores" },
      { k: "proveedores_create", l: "Crear proveedores" },
      { k: "menu_oc", l: "Ordenes de compra" },
      { k: "oc_create", l: "Crear ordenes de compra" },
      { k: "oc_autorizar", l: "Autorizar la orden", v: true },
      { k: "oc_validar", l: "Validar / quitar validacion de OC", v: true },
      { k: "oc_proforma", l: "Adjuntar proforma e importar PI" },
      { k: "oc_produccion", l: "Capturar fechas de produccion" },
      { k: "oc_cargaLista", l: "Marcar CARGA LISTA", v: true },
      { k: "compras_costear", l: "Costear articulos", v: true },
      { k: "pendiente_recibir", l: "Pendiente recibir" },
      { k: "pendiente_embarcar", l: "Pendiente embarcar" },
      { k: "proyeccionEgresos", l: "Proyeccion egresos" },
    ],
  },
  {
    grupo: "EMBARQUES",
    items: [
      { k: "embarques", l: "Embarques" },
      { k: "embarques_validar", l: "Validar / quitar validacion de embarque", v: true },
      { k: "embarques_cantidades", l: "Ajustar cantidades del embarque", v: true },
      { k: "menu_compras", l: "Entradas de embarques" },
      { k: "compras_create", l: "Crear entradas de embarques" },
      { k: "recepciones", l: "Recepcion de contenedores (captura, tarimas, cierre)", v: true },
      { k: "recepciones_auditar", l: "Auditar recepciones", v: true },
    ],
  },
  {
    grupo: "CALIDAD",
    items: [
      { k: "menuCalidad", l: "Control de calidad" },
      { k: "calidadCantidad", l: "Calidad cantidades" },
      { k: "calidadImportes", l: "Calidad importes" },
      { k: "calidad_cancelar", l: "Cancelar control de calidad", v: true },
    ],
  },
  {
    grupo: "VENTAS",
    items: [
      { k: "menu_ventas", l: "Menu ventas" },
      { k: "menu_clientes", l: "Clientes" },
      { k: "clientes_create", l: "Crear clientes" },
      { k: "grupos", l: "Grupos" },
      { k: "menu_pedidos", l: "Pedidos" },
      { k: "pedidos_create", l: "Crear pedidos" },
      { k: "pedidos_autorizar", l: "Validar existencias, cancelar y cerrar pedidos", v: true },
      { k: "pedidos_autorizar_precios", l: "Autorizar precios del pedido (excepcion)", v: true },
      { k: "pedidos_maquila", l: "Marcar maquila terminada", v: true },
      { k: "menu_surtidos", l: "Notas" },
      { k: "surtidos_create", l: "Crear notas" },
      { k: "ventas_autorizar", l: "Autorizar notas", v: true },
      { k: "surtidos_editar", l: "Editar notas (cantidades y precios)", v: true },
      { k: "entregas_registrar", l: "Registrar entregas parciales y acuses", v: true },
      { k: "ventas_cancelar", l: "Cancelar notas", v: true },
      { k: "entregarNota", l: "Entregar nota" },
      { k: "menu_devoluciones", l: "Devoluciones" },
      { k: "devoluciones_create", l: "Crear devoluciones" },
    ],
  },
  {
    grupo: "COBRANZA",
    items: [
      { k: "edoCtaClientes", l: "Estado de cuenta clientes" },
      { k: "clientes_edo_cta", l: "Estado de cuenta (cliente)" },
      { k: "pagoClientes", l: "Pago clientes" },
      { k: "reporteCobranza", l: "Reporte cobranza" },
      { k: "proyeccionIngresos", l: "Proyeccion ingresos" },
      { k: "estado_cuenta_vendedores", l: "Edo. cta. vendedores" },
    ],
  },
  {
    grupo: "INVENTARIO",
    items: [
      { k: "menu_inventarios", l: "Menu inventarios" },
      { k: "inventarios", l: "Inventarios" },
      { k: "menu_areas", l: "Almacenes" },
      { k: "menu_disponible", l: "Disponible" },
      { k: "disponible_vendedores", l: "Disponible vendedores" },
      { k: "seguimiento_inventarios", l: "Seguimiento inventarios" },
      { k: "inventarios_costos", l: "Inventarios costos" },
      { k: "inventarios_costosAdmin", l: "Inventarios costos admin" },
      { k: "ajustesInventario", l: "Ajustes de inventario" },
      { k: "autorizarAjustesInventario", l: "Autorizar ajustes de inventario", v: true },
    ],
  },
  {
    grupo: "TRASPASOS Y MUESTRAS",
    items: [
      { k: "menu_traspasos_salida", l: "Traspasos salida" },
      { k: "traspasos_salida_create", l: "Crear traspasos salida" },
      { k: "menu_traspasos_entrada", l: "Traspasos entrada" },
      { k: "traspasos_entrada_create", l: "Crear traspasos entrada" },
      { k: "traspasos_autorizar", l: "Autorizar apartado y surtido de traspasos", v: true },
      { k: "muestrasEntrada", l: "Entrada de muestras" },
      { k: "muestrasEntradaCreate", l: "Crear entrada de muestras" },
      { k: "muestrasSalida", l: "Salida de muestras" },
      { k: "muestrasSalidaCreate", l: "Crear salida de muestras" },
    ],
  },
  {
    grupo: "CXP",
    items: [
      { k: "edoCtaProveedores", l: "Estado de cuenta proveedores" },
      { k: "pagoProveedores", l: "Pagos a proveedores" },
      { k: "pagoProveedoresCreate", l: "Crear pagos a proveedores" },
      { k: "pagos_marcar", l: "Marcar pagado / simular", v: true },
      { k: "pagos_validar", l: "Validar / quitar validacion de pago", v: true },
      { k: "pagos_cancelar", l: "Cancelar pago", v: true },
      { k: "pagos_recepcion", l: "Confirmar recepcion del dinero", v: true },
      { k: "abonosProveedores", l: "Abonos a proveedores" },
      { k: "abonosProveedoresCreate", l: "Crear abonos a proveedores" },
      { k: "abonosProveedores_validar", l: "Validar abonos a proveedores", v: true },
      { k: "solicitudes_autorizar", l: "Autorizar / rechazar solicitudes de pago", v: true },
      { k: "solicitudes_ejecutar", l: "Ejecutar solicitud de pago", v: true },
    ],
  },
  {
    grupo: "GASTOS",
    items: [
      { k: "menu_gastos", l: "Menu gastos" },
      { k: "menu_admin", l: "Gastos" },
      { k: "gastos_create", l: "Crear gastos" },
      { k: "gastos_autorizar", l: "Autorizar gastos", v: true },
      { k: "gastos_cancelar", l: "Cancelar gasto", v: true },
    ],
  },
  {
    grupo: "ADMIN",
    items: [
      { k: "configAdmin", l: "Menu admin" },
      { k: "bancos", l: "Bancos" },
      { k: "menuAnticipos", l: "Anticipos" },
      { k: "anticiposCreate", l: "Crear anticipos" },
      { k: "anticipos_cancelar", l: "Cancelar anticipo", v: true },
      { k: "abonos", l: "Abonos" },
      { k: "abonosCreate", l: "Crear abonos" },
      { k: "abonos_cancelar", l: "Cancelar abono", v: true },
      { k: "notasCargo", l: "Notas de cargo" },
      { k: "notasCargoCreate", l: "Crear notas de cargo" },
      { k: "bonificaciones", l: "Bonificaciones" },
      { k: "bonificacionesCreate", l: "Crear bonificaciones" },
      { k: "comisiones", l: "Comisiones" },
      { k: "comisionesCreate", l: "Crear comisiones" },
      { k: "menu_devolucionesAdmin", l: "Devoluciones admin" },
    ],
  },
  {
    grupo: "EMPLEADOS",
    items: [
      { k: "menu_nominas", l: "Menu empleados" },
      { k: "menu_empleados", l: "Empleados" },
      { k: "empleados_create", l: "Crear empleados" },
      { k: "empleados_sueldo", l: "Sueldo empleados" },
      { k: "faltas_empleados", l: "Faltas empleados" },
      { k: "menu_puestos", l: "Puestos" },
      { k: "puestos_create", l: "Crear puestos" },
    ],
  },
  {
    grupo: "TIENDAS",
    items: [
      { k: "menuTiendas", l: "Menu tiendas" },
      { k: "inventariosTiendas", l: "Inventarios tiendas" },
      { k: "ventasTiendas", l: "Ventas tiendas" },
      { k: "listadoVentasTiendas", l: "Listado ventas tiendas" },
      { k: "gastosTiendas", l: "Gastos tiendas" },
      { k: "corteTiendas", l: "Corte tiendas" },
      { k: "abonosTiendas", l: "Abonos tiendas" },
      { k: "devolucionesTiendas", l: "Devoluciones tiendas" },
      { k: "edoCtaTiendas", l: "Edo. cta. tiendas" },
    ],
  },
  {
    grupo: "SISTEMA",
    items: [
      { k: "menu_reportes", l: "Reportes" },
      { k: "menu_usuarios", l: "Menu usuarios" },
      { k: "usuarios_create", l: "Crear usuarios" },
      { k: "usuarios_permisos", l: "Permisos de usuarios" },
      { k: "configuracion", l: "Configuracion" },
      { k: "menu_logs", l: "Logs" },
      { k: "menu_departamentos", l: "Departamentos" },
    ],
  },
];

// Llaves que NO se muestran en la pantalla pero que siguen viajando con su valor
// actual para no perderse al guardar (modulos apagados o heredados del ERP textil).
export const LLAVES_OCULTAS = [
  // Subir archivos quedo abierto a cualquiera que entre a la pantalla
  "oc_archivos",
  "embarques_archivos",
  "menu_planteles",
  "nominas_listado",
  "nominas_create",
  "nominas_pagar",
  "nominas_pagos_esp",
  "menu_edoCta_Cliente",
  "menu_cobradores",
  "menu_colores",
  "colores_create",
  "menu_tipos_telas",
  "tipos_telas_create",
  "menu_disponibleIciqlo",
  "menu_disponibleV1per",
  "menu_ingresos",
  "menu_egresos",
  "compras",
  "ventas_create",
];

export const LLAVES_PERMISOS = CATALOGO_PERMISOS.reduce(
  (acumulado, grupo) => acumulado.concat(grupo.items.map((i) => i.k)),
  []
).concat(LLAVES_OCULTAS);

export const LLAVES_VALIDACION = CATALOGO_PERMISOS.reduce(
  (acumulado, grupo) =>
    acumulado.concat(grupo.items.filter((i) => i.v).map((i) => i.k)),
  []
);
